import { FormGroup } from "@angular/forms";

export function validate(form: FormGroup): boolean {
    console.log('form', form);
    // debugger
    if (form.invalid) {
        Object.keys(form.controls).forEach((field) => {
            const control = form.get(field);
            // console.log('control', control);
            if (control) {
                control.markAsTouched({ onlySelf: true });
            }
        });
        console.log('not valid');
        return false;
    } else {
        console.log('valid');
        return true;
    }
}